<template>
	<v-container class="mt-4 px-5" fluid>
		<TicketArea v-if="verTicketsJefe" />
		<TicketAuxi v-if="verTicketsAuxiliar" />
	</v-container>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { esJefeTickets } from '@/utils/permisosTicketsValeria'

  export default {
    components: {
      TicketArea: () => import('@/views/tickets/operaciones/TicketArea.vue'),
      TicketAuxi: () => import('@/views/tickets/operaciones/TicketAuxi.vue'),
    },

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),
      verTicketsJefe () {
        return esJefeTickets(this.getdatosUsuarioERPERP)
      },
      verTicketsAuxiliar () {
        if (this.verTicketsJefe) return false
        return !!(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.cargo == 'Auxiliar')
      },
    },
  }
</script>
